import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace('#', ''));
    const sessionId = params.get('session_id');

    const processSession = async () => {
      try {
        const res = await fetch(`${API}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error('Session exchange failed');
        const user = await res.json();
        setUser(user);
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/account', { replace: true, state: { user } });
      } catch {
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true });
      }
    };

    if (sessionId) {
      processSession();
    } else {
      navigate('/', { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen flex items-center justify-center bg-white">
      <div className="h-10 w-10 border-4 border-emerald-700 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default AuthCallback;
